class bannerRedirect extends HTMLElement {
  constructor() {
    super();

    this.dev_mode = false,
    this.currentStoreUrl = window.location.origin,
    this.shopifyState = "live",
    this.param_redirect = null,

    this.countryFooterSelector = document.querySelector('.select-country-trigger');
    this.closeButton = this.querySelector('.banner-redirect__close');
    this.redirectBtn = this.querySelector('.banner-redirect__button');
    this.countrySelect = this.querySelector('#select-country');
    this.popupRedirectContent = this.querySelector('.banner-redirect__content');
    this.alertSelector1 = this.querySelector('.banner-redirect__alert--1 .alert-text');
    this.alertSelector2 = this.querySelector('.banner-redirect__alert--2 .alert-text');
    this.alertBtnSubmit = this.querySelector('.banner-redirect__submit');
    this.alertBtnContinue = this.querySelector('.banner-redirect__button--continue');
    this.alertBtnBack = this.querySelector('.banner-redirect__button--back');

    if (!this.isCustomize()) {
      this.bindEvents();
    }
  }

  bindEvents() {
    const self = this;

    this.countryFooterSelector.addEventListener('click', function() {
      self.classList.add('visible');
    });

    this.closeButton.addEventListener('click', function() {
      self.closePopup()
    });
  }

  /**
   * Check if user customize theme
   */
  isCustomize() {
    let isCustomizing = false;
    if (this.shopifyState == 'customize') {
      isCustomizing = true;
    }
    return isCustomizing;
  }

  closePopup() {
    let storeUrl = new URL(window.location.origin);
    const bannerAlerts = this.querySelectorAll('.banner-redirect__alert.hidden');

    // If show banner alert
    if (bannerAlerts.length < 2) { // Redirect to store default country
      let countrySelected = window.Shopify.country;
      if (storeUrl == this.storeAMUrl) {
        countrySelected = 'US'
      }
      if (storeUrl == this.storeROWUrl) {
        countrySelected = 'HK'
      }
      this.setCookieValue('newShippingCookie', 'true', 1);

      if (Shopify.routes.root == '/') {
        this.performRedirect(countrySelected);
      }
    }
    this.classList.remove('visible');
  }

  equalUrls(url1, url2) {
    let domain1 = (new URL(url1));
    let domain2 = (new URL(url2));
    domain1 = domain1.hostname.replace('www.', '');
    domain2 = domain2.hostname.replace('www.', '');
    return(domain1 === domain2);
  }
}

customElements.define('banner-redirect', bannerRedirect);